/**
 * A Mutex lock for {@link Promise} to ensure doing some action one at a time
 * @returns a mutex locker
 */

function mutex<T = void>() {
    let promise: Promise<T> | undefined;

    return {
        lock(action: () => Promise<T>): Promise<T> {
            if (!promise) {
                promise = action();
            }
            return promise.finally(() => {
                promise = undefined;
            });
        },
    };
}

export default mutex;
